<template>
  <SnowLocationPageContent
    :can-show-select-favorite-list-dialog="true"
    :location="location"
    selected-tab-title="Cams"
  >
    <CamViewCardList
      :cams="cams"
      :is-favorites="false"
      :locations="locations"
    />
  </SnowLocationPageContent>
</template>

<script>
import { mapActions } from 'pinia';
import { parseOpenMountainApiError } from '@@/utils/CommonUtils';
import { useLocationStore } from '@@/stores/Location';
import LocationPageMixin, { getSetupParams } from '@@/components/Location/Mixins/LocationPageMixin';

export default {
  name: 'LocationCamsPage',

  mixins: [LocationPageMixin],

  async setup() {
    const locationStore = useLocationStore();
    const params = getSetupParams();

    const { data, error } = await useAsyncData(() => locationStore.fetchCams(params));

    if (error.value) {
      throw createError(parseOpenMountainApiError(error.value));
    }

    const location = ref(data.value);
    return { location };
  },

  computed: {
    cams() {
      return this.location.cams;
    },

    locations() {
      return [this.location];
    },
  },

  methods: {
    ...mapActions(useLocationStore, ['fetchCams']),

    fetchLocation(params = {}) {
      return this.fetchCams(params);
    },
  },
};
</script>
